<template>
  <customModal :containermd="true" @closeModal="closeModal">
    <template #title>
      <h4 class="mb-0">{{ $t("navigations.forms") }}</h4>
    </template>

    <template #body>
      <div class="form-group row my-lg-2">
        <div class="col-lg-12">

          <p
           v-show="!eCRFDATA || !eCRFDATA.length"
            class="mb-0 text-center"
          >
            {{ $t("navigations.no forms added") }}
          </p>

          <table
            class="table table-bordered table-striped" 
          >
            <tbody>
              <tr v-for="(form, index) in eCRFDATA || []" :key="index">
                <td>
                  {{ form.templateName }} ({{ form.version }}) - {{ form.languageCode.toUpperCase() }} 
                </td>

                <td class="text-center">
                  <i
                    class="fa fa-eye edit-delete"
                    @click="gotoform(form.templateId)"
                  ></i>
                </td>
              </tr>
            </tbody>
          </table>

        </div>
      </div>
    </template>
  </customModal>
   <showformmodel
    v-if="setshowActivityFormModal"
    :formid="currentform"
    currentformstatus="not completed"
    @closeformModal="closeformActivityModal()"
  />
</template>

<script src="./FormListVueModal.js"></script>